<template>
  <div class="container pt-4">
    <h1 style="text-align: center">Kontakty</h1>
    <div class="row justify-content-sm-center mt-4">
      <div class="col-lg-6 pb-1">
        <div class="card">
          <div class="card-body">
            <p class="card-text">
              <i class="fa fa-home fa-2x" style="margin-right:10px"></i>
              <span style="font-weight: bold">Adresa</span><br>Kubova Huť 36, 385 01 Vimperk
            </p>
            <p class="card-text">
              <i class="fa fa-phone fa-2x" style="margin-right:10px"></i>
              <span style="font-weight: bold"
              ><span class="contact-link"
              >Mobil</span></span><br><a class="text-reset" href="tel:+420721299777">+420 721 299 777</a> - Tereza Šípová<br>
              <a class="text-reset" href="tel:+420721400285">+420 721 400 285</a> - Adam Bezpalec
            </p>
            <p class="card-text">
              <i class="fa fa-envelope fa-2x" style="margin-right:10px"></i>
              <span style="font-weight: bold">Email</span><br><a class="text-reset contact-link" href="mailto:uzdichyncu@seznam.cz">uzdichyncu@seznam.cz</a>
            </p>
            <p class="card-text">
              <i class="fa fa-map fa-2x" style="margin-right:10px"></i>
              <span style="font-weight: bold"
              >Mapy.cz</span><br>Najdete nás <a href="https://mapy.cz/zakladni?source=firm&id=1310102&x=13.7738100&y=48.9825299&z=19">zde</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contacts",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact-link {
  margin-left:5px;
}
</style>
